
export default {
    name: 'atcd-historique-allergologie-environnement-vie',
    components: {},
    props: ["consultation", "activeRole", "is_printable"],
    data() {
        return {
            is_loading: true,
            is_facteur_pro: true,
            histo_is_empty: false,
        }
    },
    computed: {
        antecedent_allergo_environnement_historique() {
            return this.$store.getters["antecedent_allergo_environnement_historique"];
        },
    },
    mounted() {
        this.listeChampATCDAllergoEnvironnement()
    },
    methods: {
        async listeChampATCDAllergoEnvironnement() {
            this.is_loading = true
            
            let filter_data = {
                consultation_id: this.consultation.id,
                data_type: 'antecedent_allergologie_environnement',
                est_en_cours: false
            }

            this.$store.dispatch('getConsultationAntecedent', filter_data).then(() => {
                if (this.antecedent_allergo_environnement_historique.length == 0) {
                    this.histo_is_empty = true
                } else {
                    this.histo_is_empty = false
                }
                this.is_loading = false
            })
        },

        toggleSection() {
            this.is_facteur_pro = (this.is_facteur_pro)?false:true
        },
    }
}


